import { render, staticRenderFns } from "./SvgLocation.vue?vue&type=template&id=3d52ea91&"
import script from "./SvgLocation.vue?vue&type=script&lang=js&"
export * from "./SvgLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports